module.exports = __webpack_public_path__ + "img/open_eye.1dfe7419.svg";